module.exports = __webpack_public_path__ + "img/artist.8bc45dfe.svg";